import {useTranslation} from "react-i18next";
import {useState} from "react";
import "moment-timezone";
import moment from "moment";
import {PRODUCTS} from "site-apps/productListModels";
import ModalLogs from "./ModalLogs";
import axiApi from "ApiCaller";
const ModalLogModel = {
    uuid: "",
    time: "",
    client: "",
    type: "",
    code: "",
    error: "",
    product: "",
    data: "",
    json: "",
};

const TableLogs = ({itemsShow, items, checkAll, setCheckAll, buttonsTB, setButtonsTB}) => {
    const [_Tt] = useTranslation("tables");
    const [_Tc] = useTranslation("choices");
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState({...ModalLogModel});

    const onClickData = async (e, idx) => {
        e.stopPropagation();
        const item = items.current.showed[idx];
        if (!item.json) {
            const dataSend = {uuid: item.uuid, time: item.time, code: item.code, type: item.type};
            const resp = await axiApi.post("/api/loggers/messages/get/json/", dataSend);
            if (resp.data?.item) {
                item.json = JSON.parse(resp.data.item);
            }
        }
        setSelectedItem(item);
        setShowModal(true);
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };

    return (
        <div className="col-12">
            {items.current.showed.length === 0 ? (
                <div className="alert alert-secondary mt-2 text-center">No hay datos de medidas disponibles</div>
            ) : (
                <>
                    <table className="table table-striped sticky-horizontal">
                        <thead>
                            <tr>
                                <th
                                    style={{
                                        minWidth: "150px",
                                        ...stickyHeaderStyle,
                                    }}
                                    className="sticky-top border-bottom-sticky ">
                                    {_Tt("UUID")}
                                </th>
                                <th
                                    style={{
                                        minWidth: "140px",
                                        ...stickyHeaderStyle,
                                    }}
                                    className="sticky-top border-bottom-sticky text-center">
                                    {_Tt("Fecha")}
                                </th>
                                <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky ">
                                    {_Tt("Data")}
                                </th>
                                <th
                                    style={{
                                        minWidth: "65px",
                                        ...stickyHeaderStyle,
                                    }}
                                    className="sticky-top border-bottom-sticky ">
                                    {_Tt("Codigo")}
                                </th>
                                <th
                                    style={{
                                        minWidth: "65px",
                                        ...stickyHeaderStyle,
                                    }}
                                    className="sticky-top border-bottom-sticky ">
                                    {_Tt("Tipo")}
                                </th>
                                <th
                                    style={{
                                        minWidth: "65px",
                                        ...stickyHeaderStyle,
                                    }}
                                    className="sticky-top border-bottom-sticky  ">
                                    {_Tt("Error")}
                                </th>
                                <th
                                    style={{
                                        minWidth: "80px",
                                        ...stickyHeaderStyle,
                                    }}
                                    className="sticky-top border-bottom-sticky  ">
                                    {_Tt("Producto")}
                                </th>
                            </tr>
                        </thead>

                        <tbody id="tbody-messagelogs">
                            {itemsShow.map((item, idx) => (
                                <tr key={idx}>
                                    <td className="">{item.uuid}</td>
                                    <td className="text-center">
                                        {moment(item.time).format("DD-MM-YYYY HH:mm")}
                                    </td>
                                    <td onClick={(e) => onClickData(e, idx)} style={{cursor: "pointer", color: "black"}}>
                                        {item.data}
                                    </td>
                                    <td>{item.code}</td>
                                    <td>{_Tc("messages_log." + item.type)}</td>
                                    <td>{item.error}</td>
                                    <td>{PRODUCTS[item.product]}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <ModalLogs showAlert={showModal} setShowAlert={setShowModal} itemSelected={selectedItem} />
                </>
            )}
        </div>
    );
};

export default TableLogs;
